module.exports = __webpack_public_path__ + "media/pages/press/downloads/LifeTime_Software-cb0ad4f860b5740ae06ca2767f0ee223.jpg";